// src/components/circles/CircleTypeBadge.tsx

import type { CircleType } from '../../types/api';
import { CIRCLE_TYPE_CHIP, CIRCLE_TYPE_LABELS } from './circleDisplay';

interface Props {
  type: CircleType;
  className?: string;
}

export default function CircleTypeBadge({ type, className }: Props) {
  return (
    <span
      className={`text-xs font-medium px-2 py-0.5 rounded-full ${CIRCLE_TYPE_CHIP[type]} ${className ?? ''}`}
      data-testid={`circle-type-badge-${type}`}
    >
      {CIRCLE_TYPE_LABELS[type]}
    </span>
  );
}
